import { render, staticRenderFns } from "./TestScreeningList.vue?vue&type=template&id=3ea4b920&scoped=true&"
import script from "./TestScreeningList.vue?vue&type=script&lang=js&"
export * from "./TestScreeningList.vue?vue&type=script&lang=js&"
import style0 from "./TestScreeningList.vue?vue&type=style&index=0&id=3ea4b920&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ea4b920",
  null
  
)

export default component.exports